import fetch from 'isomorphic-fetch'
import HomeAction from '../../home/actions/HomeAction'
import { find } from 'lodash'
import {
	ADD_LEGEND,
	ENTRY_FILTER,
	READ_NEWS,
	RECEIVE_ALL_SOURCES,
	RECEIVE_DATA_TYPE_STATISTICS,
	RECEIVE_LEGENDS,
	RECEIVE_NEWS,
	RECEIVE_THEMES,
	REMOVE_LEGEND,
	RESET_ADMINISTRATION_STORE,
	RESET_ENTRY_FILTER,
	RESET_SELECTED_FILTERS,
	RESET_SELECTED_THEMES,
	SELECTED_FILTERS,
	SELECTED_THEMES
} from '../constants/AdministrationConstants'
import { LAYERS, MASTER_THEMES, NEWS, SITE_TYPES, THEMES } from '../constants/MOCKConstants'
import ApplicationConf from '../../conf/ApplicationConf'
import { checkAuth, getJson } from '../../utils/ActionUtils'
import { WaitAction } from 'react-aquasys'

const AdministrationAction = {

	updateUser(login, userInformations) {
		return dispatch => {
			return fetch(ApplicationConf.user.saveUser(), {
				method: 'PUT',
				headers: { authorization: btoa('Basic ' + login) },
				body: JSON.stringify(userInformations)
			})
				.then(() => {
					dispatch(HomeAction.doneOnFetch('Vos informations ont bien été enregistrées'))
					dispatch(HomeAction.fetchUser(login))
				}).catch((err) => {
					dispatch(HomeAction.errorOnFetch('Impossible d\'enregistrer vos informations' + err))
				})
		}
	},
	receiveDataTypeStatistics(dataTypeStatistics) {
		return { type: RECEIVE_DATA_TYPE_STATISTICS, dataTypeStatistics }
	},

	fetchDataTypeStatistics() {
		return dispatch => {
			return fetch(ApplicationConf.dataType.getDataTypeKeyFigures(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(checkAuth)
				.then(getJson)
				.then((json = []) => {
					dispatch(AdministrationAction.receiveDataTypeStatistics(json))
				})
		}
	},

	receiveThemes(themes) {
		return { type: RECEIVE_THEMES, themes: themes }
	},

	fetchThemes() {
		return dispatch => {
			const fullThemes = MASTER_THEMES.map(o => {
				o.themes = []
				THEMES.forEach(t => {
					if (t.masterTheme === o.id) {
						t.layers = []
						LAYERS.forEach(l => {
							if (find(l.themes, tId => tId === t.id)) {
								t.layers.push(l)
							}
						})
						t.siteTypes = []
						SITE_TYPES.map(sT => {
							if (find(sT.themes, tId => tId === t.id)) {
								t.siteTypes.push(sT)
							}
						})
						o.themes.push(t)
					}
				})
				return o
			})
			dispatch(AdministrationAction.receiveThemes(fullThemes))
		}
	},
	receiveSources(sources) {
		return { type: RECEIVE_ALL_SOURCES, sources: sources }
	},
	fetchSources() {
		return dispatch => {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.referencial.getSources(), {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then(getJson)
				.then((json = []) => {
					return dispatch(AdministrationAction.receiveSources(json))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},

	resetSelectedThemes() {
		return { type: RESET_SELECTED_THEMES }
	},

	receiveSelectedThemes(selectedThemes) {
		return { type: SELECTED_THEMES, selectedThemes }
	},

	selectedThemes(selectedThemes) {
		return dispatch => {
			dispatch(AdministrationAction.receiveSelectedThemes(selectedThemes))
		}
	},

	resetSelectedFilters() {
		return { type: RESET_SELECTED_FILTERS }
	},
	selectedFilters(selectedFilters) {
		AdministrationAction.resetSelectedFilters()
		return { type: SELECTED_FILTERS, selectedFilters }
	},
	resetEntry() {
		return { type: RESET_ENTRY_FILTER }
	},
	resetAdministrationStore() {
		return { type: RESET_ADMINISTRATION_STORE }
	},
	updateEntry(filterEntry) {
		return { type: ENTRY_FILTER, filterEntry }
	},
	setLegends(legends) {
		return { type: RECEIVE_LEGENDS, legends }
	},
	addLegend(legend) {
		return { type: ADD_LEGEND, legend }
	},
	removeLegend(legendId) {
		return { type: REMOVE_LEGEND, legendId: legendId }
	},

	fetchNews: () => dispatch => {
		dispatch(AdministrationAction.receiveNews(NEWS))
	},

	updateNews: news => dispatch => {
		dispatch(AdministrationAction.readNews(news))
	},

	readNews(news) {
		return { type: READ_NEWS, news }
	},

	receiveNews(news) {
		return { type: RECEIVE_NEWS, news }
	}

}

export default AdministrationAction



// WEBPACK FOOTER //
// ./src/administration/actions/AdministrationAction.js